<ngx-ui-loader></ngx-ui-loader>
<div id="distribution" class="page-layout simple tabbed">
  <conciliation-header></conciliation-header>
  <div class="page-wrapper">
    <complex-selector (complexConn)="sendComplexId($event)"></complex-selector>
    <conciliation-table [complexId]="complexId"></conciliation-table>
  </div>
</div>